import utils from "appdevresources/plugin.utls.jquery";

// Project-level libraries and styles
import "ega-redux/shared";

// This is here to ensure that jQuery is available outside of webpack.
if (typeof global.jQuery === "undefined") {
    global.$ = global.jQuery = jQuery;
}

import "ega-redux-css/main.scss";
import "appdevresources/navigation-menu-builder";
import {initializeToolTips, loadSpinner, unloadSpinner} from "appdevresources/common";

$(document).on({ajaxStart: loadSpinner, ajaxStop: unloadSpinner});

$(function() {
    initializeToolTips($(".nav-link"));

    $(".modal").on("hidden.bs.modal", () => unloadSpinner()); // make sure spinner is unloaded just in case it gets called.

    $("[data-toggle=collapse]").each(function() {
        const target = $(this).data("target");
        const save = $(this).data("save") ?? true;

        if (save) {
            $(target).on("shown.bs.collapse", () => {
                localStorage.setItem(`collapse-${target}`, 'show');
            }).on("hidden.bs.collapse", () => {
                localStorage.setItem(`collapse-${target}`, 'hide');
            });

            if (localStorage.getItem(`collapse-${target}`) !== null) {
                $(target).collapse(localStorage.getItem(`collapse-${target}`))
            }
        }
    });
});

console.debug("Loaded app: ega-redux");
